export default __webpack_public_path__ + "static/pay_compare_comp3_active-fe8d5ece3fb6f967f12ec346c7b73905.png";